'use strict';

/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*exported K2Modal */
function K2Modal(id) {
  this.id = id;
  this.opened = false;
  this.$modal = null;
  this.setting = {};
  this.defaultSetting = {};

  this.init();
}

K2Modal.prototype = $.extend({}, {
  constructor: 'K2Modal',

  registerCommonCallbacks: function registerCommonCallbacks() {
    var _this = this;

    var scrollHandler = function () {
      if (!isEmpty(_this.setting.scrollCallback)) {
        if (_this.setting.scrollCallback) {
          if ($.isFunction(_this.setting.scrollCallback)) {
            _this.setting.scrollCallback();
          } else {
            window[_this.setting.scrollCallback]();
          }
        }
      }

      _this.$modal.trigger('scrollModal');
    };

    var openHandler = function () {
      if (!isEmpty(_this.setting.openCallBack)) {
        if ($.isFunction(_this.setting.openCallBack)) {
          _this.setting.openCallBack();
        } else {
          window[_this.setting.openCallBack]();
        }
      }

      return false;
    };

    var closeHandler = function () {
      if (!isEmpty(_this.setting.closeCallBack)) {
        if ($.isFunction(_this.setting.closeCallBack)) {
          _this.setting.closeCallBack();
        } else {
          window[_this.setting.closeCallBack]();
        }
      }

      _this.afterClose();

      //musime overit a pripadne nastvit modal-open ... pokud je vice modalu otevreno, muze se zavrit
      if ($('.modal:visible').length) {
        $(document.body).addClass('modal-open');
      }

      return false;
    };

    _this.$modal.find('.modal-body').bind('scroll', scrollHandler);
    _this.$modal.bind('shown.bs.modal', openHandler);
    _this.$modal.bind('hidden.bs.modal', closeHandler);

    return _this;
  },

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.registerCommonCallbacks();

    var submitHandler = function () {
      if (!isEmpty(_this.setting.submitCallBack)) {
        if ($.isFunction(_this.setting.submitCallBack)) {
          _this.setting.submitCallBack({ button: $(this).data('button') });
        } else {
          window[_this.setting.submitCallBack]({ button: $(this).data('button') });
        }
      }

      return false;
    };

    var enterSubmitHandler = function (e) {
      var keyCode = e.originalEvent.keyCode || e.originalEvent.which || e.originalEvent.charCode || e.originalEvent.code;

      if (keyCode === 13) {
        if (!isEmpty(_this.setting.enterSubmitCallBack)) {
          if ($.isFunction(_this.setting.enterSubmitCallBack)) {
            _this.setting.enterSubmitCallBack();
          } else {
            window[_this.setting.enterSubmitCallBack]();
          }
        }

        return false;
      }
    };

    _this.$modal.find('.modal-footer .submit').bind('click', submitHandler);
    _this.$modal.find('.modal-body').on('keydown', 'input:not(.form--allowed-enter input)', enterSubmitHandler);
  },

  setModalParams: function setModalParams() {
    var _this = this;

    if (!isEmpty(_this.$modal.data('modal_class'))) {
      _this.$modal.removeClass(_this.$modal.data('modal_class'));
    }

    if (!isEmpty(_this.setting.modalClass)) {
      _this.$modal.addClass(_this.setting.modalClass);
      _this.$modal.data('modal_class', _this.setting.modalClass);
    }

    _this.$modal.find('.modal-body').css('overflow-y', 'auto');

    _this.setTitle(_this.setting.title);
    _this.content(_this.setting.content);
  },

  setModalForm: function setModalForm() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit[data-button="1"]').html(_this.setting.saveBtnTitle);
    _this.$modal.find('.modal-footer .submit[data-button="2"]').html(_this.setting.saveBtn2Title);

    _this.$modal.find('.modal-footer .submit').prop('disabled', false);
    _this.$modal.find('.modal-footer .submit').hide();

    if (_this.setting.form) {
      _this.$modal.find('.modal-footer .submit[data-button="1"]').show();
    }

    if (_this.setting.viewSubmit2Btn) {
      _this.$modal.find('.modal-footer .submit[data-button="2"]').show();
    }

    _this.$modal.find('.modal-button__cancel').html(_this.setting.closeBtnTitle);
    _this.$modal.find('.modal-button__cancel').hide();
    if (_this.setting.viewCancelBtn) {
      _this.$modal.find('.modal-button__cancel').show();
    }
  },

  setModalDimensions: function setModalDimensions() {
    var _this = this;

    if (_this.setting.minHeight) {
      _this.$modal.find('.modal-body').css('min-height', _this.setting.minHeight);
    } else {
      _this.$modal.find('.modal-body').css('min-height', 'auto');
    }

    if (_this.setting.height) {
      _this.$modal.find('.modal-body').css('max-height', _this.setting.height);
      _this.$modal.find('.modal-body').css('height', _this.setting.height);
    } else {
      _this.$modal.find('.modal-body').css('max-height', $(window).height() * 0.7);
      _this.$modal.find('.modal-body').css('height', $(window).height() * 0.7);
    }

    _this.width(_this.setting.width);
    _this.maxWidth(_this.setting.maxWidth);
  },

  openInternal: function openInternal(setting) {
    var _this = this;

    _this.setting = $.extend({}, _this.defaultSetting, setting);

    _this.setModalParams();
    _this.setModalForm();
    _this.setModalDimensions();

    _this.$modal.modal({ backdrop: 'static', keyboard: _this.setting.keyboardClose });

    if (!_this.opened) {
      _this.$modal.modal('show');
    }

    _this.unBlock();
    _this.setFocus();
    _this.opened = true;

    return _this;
  },

  open: function open(setting) {
    var _this = this;

    return _this.openInternal(setting);
  },

  setTitle: function setTitle(title) {
    var _this = this;

    _this.$modal.find('.modal-title').html(title);

    return _this;
  },

  title: function title(title) {
    var _this = this;

    if (title) {
      _this.$modal.find('.modal-title').html(title);
    }

    return _this.$modal.find('.modal-title').text();
  },

  setFocus: function setFocus(forceFocus) {
    var _this = this;

    forceFocus = forceFocus || false;

    if (_this.setting.focusInput || forceFocus) {
      setTimeout(function () {
        var $input = _this.contentDOM().find('input:text, textarea').filter(':first');
        if ($input.length) {
          $input.focus();
        }
      }, _this.setting.focusTimeout);
    }

    return _this;
  },

  afterCloseInternal: function afterCloseInternal() {
    var _this = this;

    return _this;
  },

  afterClose: function afterClose() {
    var _this = this;

    _this.opened = false;

    return _this.afterCloseInternal();
  },

  closeInternal: function closeInternal() {
    var _this = this;

    _this.$modal.modal('hide');

    return _this;
  },

  close: function close(callBack) {
    var _this = this;

    if (callBack) {
      _this.setting.closeCallBack = callBack;
    }

    return _this.closeInternal();
  },

  closeWithnoutCallback: function closeWithnoutCallback() {
    var _this = this;

    _this.setting.closeCallBack = null;

    return _this.closeInternal();
  },

  content: function content(content, skipFocus) {
    var _this = this;

    skipFocus = skipFocus || false;

    if (!(typeof content === 'undefined' || content === null)) {
      _this.$modal.find('.modal-body').empty();
      _this.$modal.find('.modal-body').html(content);

      if (!skipFocus) {
        _this.setFocus();
      }
    }

    return _this.$modal.find('.modal-body').html();
  },

  contentDOM: function contentDOM() {
    var _this = this;

    return _this.$modal.find('.modal-body');
  },

  empty: function empty() {
    var _this = this;

    _this.$modal.find('.modal-body').empty();

    return _this;
  },

  submit: function submit() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit').trigger('click');

    return _this;
  },

  isOpen: function isOpen() {
    var _this = this;

    return _this.opened;
  },

  block: function block() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit').prop('disabled', true);
    blockElement(_this.$modal.find('.modal-body'));

    return _this;
  },

  unBlock: function unBlock() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit').prop('disabled', false);
    unBlockElement(_this.$modal.find('.modal-body'));

    return _this;
  },

  width: function width(width) {
    var _this = this;

    var $modalDialog = _this.$modal.find('.modal-dialog');
    if (!isEmpty($modalDialog.data('width'))) {
      $modalDialog.removeClass('modal-' + $modalDialog.data('width'));
    }

    if (!isEmpty(width)) {
      $modalDialog.data('width', width);
      $modalDialog.addClass('modal-' + width);
    }

    return _this;
  },

  maxWidth: function maxWidth(maxWidth) {
    var _this = this;

    var $modalDialog = _this.$modal.find('.modal-dialog');
    $modalDialog.css('maxWidth', 'auto');

    if (!isEmpty(maxWidth)) {
      $modalDialog.css('maxWidth', maxWidth);
    }

    return _this;
  },

  defineK2ModalSetting: function defineK2ModalSetting() {
    var _this = this;

    _this.defaultSetting = $.extend({}, {
      title: services.get('translator').trans('modal.title'),
      saveBtnTitle: services.get('translator').trans('form.save'),
      saveBtn2Title: services.get('translator').trans('form.save'),
      closeBtnTitle: services.get('translator').trans('modal.close'),
      width: 'md',
      maxWidth: null,
      height: null,
      minHeight: null,
      modalMargin: 10,
      modalClass: '',
      keyboardClose: true,
      content: '',
      scrollCallback: null,
      submitCallBack: null,
      enterSubmitCallBack: null,
      openCallBack: null,
      closeCallBack: null,
      focusInput: true,
      focusTimeout: 300,
      viewSubmit2Btn: false,
      viewCancelBtn: true
    });
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.defineK2ModalSetting();

    var modalStr = '';
    modalStr += '<div class="modal fade ' + _this.defaultSetting.modalClass + '" tabindex="-1" role="dialog" id="' + _this.id + '" data-modal_class="' + _this.defaultSetting.modalClass + '">';
    modalStr +=   '<div class="modal-dialog" role="document">';
    modalStr +=     '<div class="modal-content">';
    modalStr +=       '<div class="modal-header">';
    modalStr +=          '<button type="button" class="close" data-dismiss="modal" aria-label="' + _this.defaultSetting.closeBtnTitle + '"><span aria-hidden="true">&times;</span></button>';
    modalStr +=          '<h4 class="modal-title">' + _this.defaultSetting.title + '</h4>';
    modalStr +=       '</div>';
    modalStr +=       '<div class="modal-body">' + _this.defaultSetting.content + '</div>';
    modalStr +=       '<div class="modal-footer">';
    modalStr +=         '<button type="button" class="btn btn-default pull-left modal-button__cancel" data-dismiss="modal">' + _this.defaultSetting.closeBtnTitle + '</button>';
    modalStr +=         '<button type="button" class="btn btn-primary submit modal-button__submit" data-button="1">' + _this.defaultSetting.saveBtnTitle + '</button>';
    modalStr +=         '<button type="button" class="btn btn-primary submit modal-button__submit2" data-button="2">' + _this.defaultSetting.saveBtn2Title + '</button>';
    modalStr +=       '</div>';
    modalStr +=     '</div>';
    modalStr +=   '</div>';
    modalStr += '</div>';

    _this.$modal = $(modalStr);

    $('body').append(_this.$modal);

    _this.registerCallbacks();
  }
});
